import { createContext } from 'react';
import type { NostrEvent, NostrMetadata } from '@nostrify/nostrify';

export interface AuthorData {
  event?: NostrEvent;
  metadata?: NostrMetadata;
}

export interface AuthorBatchContextType {
  /**
   * Request kind-0 metadata for a pubkey. Calls within a short window are
   * coalesced into a single batched relay query.
   */
  load: (pubkey: string) => Promise<AuthorData>;
}

export const AuthorBatchContext = createContext<AuthorBatchContextType | undefined>(undefined);
